/* tslint:disable */
/* eslint-disable */
/**
 * CVAT REST API
 * REST API for Computer Vision Annotation Tool (CVAT)
 *
 * The version of the OpenAPI document: 2.31.0
 * Contact: support@cvat.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `queued` - Queued * `started` - Started * `failed` - Failed * `finished` - Finished
 * @export
 * @enum {string}
 */

export const RequestStatus = {
    Queued: 'queued',
    Started: 'started',
    Failed: 'failed',
    Finished: 'finished'
} as const;

export type RequestStatus = typeof RequestStatus[keyof typeof RequestStatus];



